var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.257 11.686"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48",
    d: "M.707.707l5.136 5.136-5.136 5.136",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "6973e4a6f707c58d2376f688ccfb4a95.svg";
export { SvgChevronRight as ReactComponent };